import * as request from "@/utils/request";

export default {
	// 公域任务 任务交付记录
	post_task_privatejoinList(data) {
		return request.post("/paas/daily_task/join_list", data);
	},
	// 公域任务 公域任务交付审核
	post_task_privatejoinAudit(id,data) {
		return request.post(`/paas/daily_task/audit/${id}`, data);
	},
	// 公域任务 公域任务交付编辑
	post_task_privatejoinUpdate(id, data) {
		return request.post(`/paas/daily_task/update/${id}`, data);
	},
	// 公域任务 公域任务交付详情
	post_task_privatejoinInfo(data) {
		return request.post(`/paas/daily_task/deliver_view`, data);
	},
	/*
	 ***********************************私域任务*************************************
	 */
	// 私域任务 任务交付记录
	post_deliver_privatejoinList(data) {
		return request.post("/paas/mission/join/list", data);
	},
	// 私域任务 任务交付审核
	post_deliver_privatejoinExamine(id, data) {
		return request.post(`/paas/mission/join/examine/${id}`, data);
	},
	// 私域任务 任务交付编辑
	post_deliver_privatejoinUpdate(id, data) {
		return request.post(`/paas/mission/join/update/${id}`, data);
	},
	// 私域任务 任务交付详情
	post_deliver_privatejoinInfo(id) {
		return request.post(`/paas/mission/join/info/${id}`);
	},
	// 私域任务交付批量审核
	post_deliver_privatejoinAllExamine(data) {
		return request.post(`/paas/mission/join/all_examine`, data);
	},
};
